import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
//Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	
// Participant/Get/{AuthToken}/{ParticipantGuid}/
// Group/Participant/Create     POST BODY: has userName	

export const updateProfileDemographics = createAsyncThunk('profileDemographic/update', async (incomingVariable, thunkAPI) => {
    const bodies = incomingVariable
    
    try {
        const response = await axios.post(PLATFORM
            + "Participant/Update", bodies
        )
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const updateProfileAddress = createAsyncThunk('profileAddress/update', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.post(PLATFORM
            + "Participant/Address/Update/" + incomingVariable
        )
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const createProfileAddress = createAsyncThunk('profileAddress/create', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.post(PLATFORM
            + "Participant/Address/Create/" + incomingVariable
        )
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        profileClear(state, action) {
            state.entities = initialState.entities
            state.status = "idle"
        }
    },
    extraReducers(builder) {
        builder
            .addCase(updateProfileDemographics.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(updateProfileDemographics.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {
                    state.error = null
                    state.status = 'success'
                    const loadedData = action.payload.Info[0]

                    state.entities[loadedData.ParticipantGuid] = loadedData
                } else {
                    state.status = 'failed'
                    state.error = action.payload.Status[0]
                }
            })
            .addCase(updateProfileDemographics.rejected, (state, action) => {
                state.error = action.error.message
                state.status = "failed"
            })

    }
})

export const { profileClear } = profileSlice.actions

export default profileSlice.reducer

const selectProfileEntities = (state) => state.profile.entities

export const selectProfile = createSelector(selectProfileEntities, (entities) =>
    Object.values(entities)
)
